import React, { FC, forwardRef, RefAttributes } from 'react';
import { TextArea } from '@trip-ux/components';
import { FieldRenderProps } from 'react-final-form';
import { get, defaultTo } from 'lodash';

export const GenericTextArea: FC<
  FieldRenderProps<string> & RefAttributes<HTMLTextAreaElement> & { ariaLabel?: string }
> = forwardRef(
  (
    {
      label: propLabel,
      labels,
      ariaLabel,
      input,
      meta,
      placeholder,
      rows,
      showLabel = false,
      className = '',
      disabled = false,
      maxLength,
      showCount
    },
    ref
  ) => {
    const label = defaultTo(propLabel, get(labels, input.name, ''));
    return (
      <div className={`mb-auto space-between ${className}`}>
        <TextArea
          {...input}
          id={input.name}
          disabled={disabled}
          className="my-auto text-input-policy"
          placeholder={defaultTo(placeholder, label)}
          rows={rows}
          maxLength={maxLength}
          error={meta.error}
          ref={ref}
          showCount={showCount}
          showLabel={showLabel}>
          {showLabel ? label : ariaLabel}
        </TextArea>
      </div>
    );
  }
);
GenericTextArea.displayName = 'GenericTextArea';
